import { createEntityItemId, parseEntityItemId } from '@wix/a11y-rules';
import { RequestedFields } from '@wix/ambassador-stores-catalog-v3-product/types';
import _ from 'lodash';
export const buildBulkUpdatePayloadV1 = (altTextData, productsMap) => {
  return altTextData.map(_ref => {
    var _media$mainMedia, _media$items, _media$mainMedia2, _media$items2;
    let {
      id,
      alt,
      entityId
    } = _ref;
    const {
      itemId: imageId
    } = parseEntityItemId(id, 1);
    const product = productsMap.get(entityId);
    if (!product) {
      return;
    }
    const {
      id: productId,
      media
    } = product;
    const mediaItem = imageId === (media == null || (_media$mainMedia = media.mainMedia) == null ? void 0 : _media$mainMedia.id) ? media == null ? void 0 : media.mainMedia : media == null || (_media$items = media.items) == null ? void 0 : _media$items.find(_ref2 => {
      let {
        id: mediaId
      } = _ref2;
      return mediaId === imageId;
    });
    const mediaIndex = imageId === (media == null || (_media$mainMedia2 = media.mainMedia) == null ? void 0 : _media$mainMedia2.id) ? 0 : media == null || (_media$items2 = media.items) == null ? void 0 : _media$items2.findIndex(_ref3 => {
      let {
        id: mediaId
      } = _ref3;
      return mediaId === imageId;
    });
    const updatedMediaItem = {
      ...(mediaItem == null ? void 0 : mediaItem.image),
      altText: alt,
      id: mediaItem == null ? void 0 : mediaItem.id,
      index: mediaIndex,
      mediaType: 'PHOTO',
      title: mediaItem == null ? void 0 : mediaItem.title,
      url: mediaItem == null ? void 0 : mediaItem.id
    };
    return {
      data: {
        id: productId,
        media: {
          ...updatedMediaItem
        }
      },
      name: 'UpdateProductMediaItem'
    };
  });
};
export const buildBulkUpdatePayloadV3 = (altTextData, productsMap) => {
  const updatedProducts = [];
  const altUpdatedByProductId = _.groupBy(altTextData, data => data.entityId);
  Object.entries(altUpdatedByProductId).forEach(_ref4 => {
    var _originalItemInfo$ite;
    let [productId, updatesForProduct] = _ref4;
    const product = productsMap.get(productId);
    if (!product) {
      return;
    }
    const {
      media: originalMedia
    } = product;
    const {
      itemsInfo: originalItemInfo,
      main: originalMain
    } = originalMedia || {};
    const altMap = Object.fromEntries((updatesForProduct || []).map(_ref5 => {
      let {
        id,
        alt
      } = _ref5;
      return [id, alt];
    }));
    const updatedMedia = {
      ...originalMedia,
      itemsInfo: {
        ...originalItemInfo,
        items: originalItemInfo == null || (_originalItemInfo$ite = originalItemInfo.items) == null ? void 0 : _originalItemInfo$ite.map(item => {
          const newAltText = item.id && altMap[createEntityItemId([productId], item.id)];
          if (newAltText === undefined) {
            return item;
          }
          const {
            altText,
            ...rest
          } = item;
          return newAltText ? {
            ...rest,
            altText: newAltText
          } : {
            ...rest
          };
        })
      },
      main: originalMain != null && originalMain.id ? {
        ...originalMain,
        altText: altMap[originalMain.id] ?? originalMain.altText
      } : originalMain
    };
    updatedProducts.push({
      product: {
        id: product.id,
        media: updatedMedia,
        revision: product.revision
      }
    });
  });
  const payload = {
    fields: [RequestedFields.MEDIA_ITEMS_INFO, RequestedFields.URL],
    products: updatedProducts,
    returnEntity: true
  };
  return payload;
};
//# sourceMappingURL=bulk-update-product-alt-text-payload-builder.js.map